@for (item of totalsWithChangedOrder; track $index; let first = $first) {
<div class="flex flex-justify-between col-1"
     [class.m-t]="!first && item.id === 'total'"
     [class.s1]="item.id === 'total'"
     [ngClass]="item.id === 'total' && !isMinibasket ? 's1 m-t-3 b-t p-t-3 b-col-4' : 'p1 m-t-2'">
    <label>{{item.label | translate}}@if(couponLabel?.length && item.id ===
        "discount"){<p class="p2 inline">&nbsp;{{couponLabel}}</p>&nbsp;<remove-coupon></remove-coupon>}</label>
    <price class="price"
           [useFreeLabel]="true"
           [value]="item.value"
           [ngClass]="item.id === 'total' ? 's1' : 'p1'"></price>
</div>
}

<!-- paypal pay in three template -->
@if (basket.totals?.grand_total && !hidePaypalPayInThreeMessage()) {
<paypal-pay-in-three-message class="m-t-4"
                             [mode]="'basket'"
                             [amount]="basket.totals?.grand_total"></paypal-pay-in-three-message>
}
